import { useState } from 'react';
import Image from 'next/image';
import LoginForm from '../LoginForm';
import SignupForm from '../SignupForm';
import { loginIllustration as aroundTheWorldIcon } from 'assets/illustrations';
import BaseModal from './BaseModal';
import { useTranslation } from 'next-i18next/pages';

export enum LoginSignupModalType {
  LOGIN = 'LOGIN',
  SIGNUP = 'SIGNUP',
}

interface Props {
  modalType: LoginSignupModalType;
  closeModal: () => void;
  content?: any;
  modalOpen: boolean;
  // Opened by Search: says why it asks. The navbar opens it with a pending
  // page too (Settings, My bookings), where that sentence would be wrong.
  searchReason?: boolean;
}

const LoginSignupModal: React.FC<Props> = ({
  modalType,
  closeModal,
  content,
  modalOpen,
  searchReason = false,
}) => {
  const [selectedModal, setSelectedModal] =
    useState<LoginSignupModalType>(modalType);
  const { t } = useTranslation();

  // Follow a new modalType from the parent, adjusted during render.
  const [prevModalType, setPrevModalType] = useState(modalType);
  if (modalType !== prevModalType) {
    setPrevModalType(modalType);
    setSelectedModal(modalType);
  }

  return (
    <BaseModal closeModal={closeModal} modalOpen={modalOpen}>
      <div className="flex flex-col items-center justify-center">
        <Image
          src={aroundTheWorldIcon}
          className="max-h-52 w-full h-full"
          alt=""
        />
        {/* Opened by Search: say why it asks, and that it need not
            (WHIT-494). It opened with no word of explanation. */}
        {searchReason && (
          <p className="mt-3 text-center text-sm text-tt-light-gray-purple w-full md:w-4/5">
            {t('search_sign_in_reason')}
          </p>
        )}
        <div className="flex mt-3 text-center sm:mt-4 w-full md:w-4/5 ">
          <button
            onClick={() => setSelectedModal(LoginSignupModalType.LOGIN)}
            className={`text-lg leading-6 font-medium text-gray-900 self-center flex-1 ${
              selectedModal === LoginSignupModalType.LOGIN &&
              'border-b-2 border-b-tt-yellow font-bold'
            }`}>
            {t('Login')}
          </button>
          <button
            onClick={() => setSelectedModal(LoginSignupModalType.SIGNUP)}
            className={`text-lg leading-6 font-medium text-gray-900 self-center flex-1 ${
              selectedModal === LoginSignupModalType.SIGNUP &&
              'border-b-2 border-b-tt-yellow font-bold'
            }`}>
            {t('Sign up')}
          </button>
        </div>
        {selectedModal === LoginSignupModalType.LOGIN ? (
          <LoginForm closeModal={closeModal} content={content} />
        ) : (
          <SignupForm closeModal={closeModal} content={content} />
        )}
      </div>
    </BaseModal>
  );
};

export default LoginSignupModal;
